import { ApiService } from '../apiService'
import {
  StatisticsJobStatusDto,
  StartStatisticsRebuildRequest,
  StartJobResultDto,
  ActivityLogListDto,
  DailyUserStatisticsDto,
  DailyAdventureStatisticsDto,
  DailyGroupStatisticsDto,
  StatisticsLogsParams,
  UserStatisticsParams,
  AdventureStatisticsParams,
  GroupStatisticsParams,
  PaginatedResponse,
} from '../types/statistics'
import { DashboardStatisticsDto } from '../types/dashboard'

export const statisticsApi = {
  // Get current status of statistics jobs
  getStatus: () =>
    ApiService.get<StatisticsJobStatusDto>('/admin/statistics/status'),

  // Start a statistics rebuild operation
  startRebuild: (request: StartStatisticsRebuildRequest) =>
    ApiService.post<StartJobResultDto>('/admin/statistics/start', request),

  // Stop an active statistics rebuild
  stopRebuild: () =>
    ApiService.post<void>('/admin/statistics/stop', {}),

  // Get activity logs for statistics operations
  getLogs: (params?: StatisticsLogsParams) =>
    ApiService.get<ActivityLogListDto>('/admin/statistics/logs', params),

  // Get daily user statistics (server-side pagination/sorting)
  getUserStatistics: (params: UserStatisticsParams) =>
    ApiService.get<PaginatedResponse<DailyUserStatisticsDto>>('/admin/statistics/users', params),

  // Get daily adventure statistics (server-side pagination/sorting)
  getAdventureStatistics: (params: AdventureStatisticsParams) =>
    ApiService.get<PaginatedResponse<DailyAdventureStatisticsDto>>('/admin/statistics/adventures', params),

  // Get daily group statistics (server-side pagination/sorting)
  getGroupStatistics: (params: GroupStatisticsParams) =>
    ApiService.get<PaginatedResponse<DailyGroupStatisticsDto>>('/admin/statistics/groups', params),

  // Get dashboard statistics with aggregated data
  getDashboard: (params: { days: number }) =>
    ApiService.get<DashboardStatisticsDto>('/admin/statistics/dashboard', params),
}
